import { createFileRoute, redirect } from '@tanstack/react-router';
import { CatalogoPageAuth } from '@/features/catalogo/page/auth/CatalogoPageAuth';
import { useCatalogoStore } from '@/features/catalogo/store/store';

export const Route = createFileRoute('/p/catalogo/$slug/auth')({
    beforeLoad: ({ params }) => {
        const { isUserLogged, getTokenStatus } = useCatalogoStore.getState();

        if (isUserLogged() && getTokenStatus().status === 'valid') {
            throw redirect({ params, to: '/p/catalogo/$slug/produtos' });
        }
    },
    component: CatalogoPageAuth,
});
